import { Route as CustomerWiseReportRoute } from "@/routes/(inventory)/branch/_layout/reports/customer-wise-revenue/index";
import { useQuery } from "@tanstack/react-query";
import { getCustomerRevenue } from "../-data/api";
import { CustomerProfitabilityItem } from "@/gen/reports/common_pb";

interface ReportQueryResult {
    items: CustomerProfitabilityItem[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export const useCustomerRevenueData = () => {
    const searchParams = CustomerWiseReportRoute.useSearch();
    const page = searchParams.page || 1;
    const pageSize = searchParams.pageSize || 10;

    return useQuery<ReportQueryResult>({
      queryKey: ["customer-revenue", searchParams],
      queryFn: async () => {
        const response = await getCustomerRevenue(searchParams.page, searchParams.pageSize);
        
        return {
          items: response.customerProfitabilityItems,
          totalCount: response.totalCount,
          page: page,
          pageSize: pageSize,
        };
      },
        // Keep previous data while fetching new data for better UX
        placeholderData: (previousData) => previousData,
        // Don't refetch when window regains focus
        refetchOnWindowFocus: false,
        // Stale time - how long data stays fresh (5 minutes)
        staleTime: 5 * 60 * 1000,
        // Cache time - how long inactive data stays in cache (10 minutes)
        gcTime: 10 * 60 * 1000,
    });
  };